import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de homeopatico
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarHomeopaticos(props) {
  useEffect(() => {
    const title = 'homeopatico.cadastroDeHomeopatico';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'homeopaticos'}
      insumoEnum={Insumo.HOMEOPATICO}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'homeopatico.' +
          (props.match.params.id ? 'homeopaticoEditadoComSucesso' : 'homeopaticoCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'homeopatico.' +
          (props.match.params.id ? 'falhaAoEditarHomeopatico' : 'falhaAoCadastrarHomeopatico')
      )}
      falhaCarregarMensagem={formatMessage('homeopatico.falhaAoCarregarHomeopatico')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarHomeopaticos));
